import { render, staticRenderFns } from "./GenerateKey.vue?vue&type=template&id=56f4fabd&scoped=true&"
import script from "./GenerateKey.vue?vue&type=script&lang=js&"
export * from "./GenerateKey.vue?vue&type=script&lang=js&"
import style0 from "./GenerateKey.vue?vue&type=style&index=0&id=56f4fabd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f4fabd",
  null
  
)

export default component.exports